/**
 * Formatiert Ablaufdaten von APNs-/DEP-Tokens für die Anzeige.
 */
export function formatDateTime(iso) {
  if (!iso) return 'unbekannt';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString('de-DE', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
}

export function expiryLabel(iso, daysRemaining) {
  if (!iso) return 'Ablaufdatum unbekannt';
  const days = typeof daysRemaining === 'number'
    ? daysRemaining
    : Math.ceil((new Date(iso).getTime() - Date.now()) / (24 * 60 * 60 * 1000));
  if (!Number.isFinite(days)) return `gültig bis ${formatDateTime(iso)}`;
  if (days < 0) return `abgelaufen am ${formatDateTime(iso)}`;
  if (days === 0) return `läuft heute ab (${formatDateTime(iso)})`;
  if (days === 1) return `läuft morgen ab (${formatDateTime(iso)})`;
  return `gültig bis ${formatDateTime(iso)} · noch ${days} Tage`;
}

export function expiryBadgeClass(status) {
  if (status === 'ok') return 'text-bg-success';
  if (status === 'expiring') return 'text-bg-warning';
  if (status === 'expired') return 'text-bg-danger';
  return 'text-bg-secondary';
}
